<form class="search-form">
  <mat-form-field
    class="search-field custom-field no-hint"
    appearance="fill"
    [ngClass]="{
      menu: isMenuOpened()
    }"
    (click)="$event.stopPropagation()"
  >
    <input
      type="text"
      placeholder="Press Enter for Quick Search"
      aria-label="Search"
      matInput
      [formControl]="getSearchControl()"
      (keyup.enter)="onPressEnter()"
      (focus)="triggerSearchOpen()"
      (click)="$event.stopPropagation()"
    />
    <mat-icon color="primary" matPrefix>search</mat-icon>
    <button
      [type]="'button'"
      mat-icon-button
      matSuffix
      #filterTrigger="matMenuTrigger"
      [matMenuTriggerFor]="filterMenu"
      (menuOpened)="onMenuOpened()"
      (menuClosed)="isMenuOpen = false"
      (click)="$event.stopPropagation()"
    >
      <mat-icon color="primary">filter_list</mat-icon>
    </button>
  </mat-form-field>
  <mat-menu
    #filterMenu="matMenu"
    [class]="'custom-menu'"
    [overlapTrigger]="false"
    [xPosition]="'before'"
    [hasBackdrop]="false"
  >
    <div class="filter-menu-container" [formGroup]="filterGroup">
      <div class="flex-header">
        <h6>Filter By</h6>
        <button mat-button color="primary" (click)="onClearFilters($event)">
          Clear
        </button>
      </div>

      <div class="form-row">
        @if (recordTypes.length > 0) {
        <div class="custom-form-field">
          <label for="recordTypeIds">Record Type</label>
          <app-mat-multi-select
            [size]="'sm'"
            [options]="recordTypes"
            [control]="filterGroup.controls['recordTypeIds']"
            (click)="$event.stopPropagation()"
          />
        </div>
        }
        @if ((role !== 'Provider' && role !== 'ProviderReadOnly') || (providers && providers.length > 1)) {
        <div class="custom-form-field">
          <label for="providerOrganizationId">Provider</label>
          <mat-form-field
            appearance="outline"
            class="custom-field sm"
            (click)="$event.stopPropagation()"
          >
            <mat-select
              formControlName="providerOrganizationId"
              name="providerOrganizationId"
            >
              <div class="options-container" #optionsContainer>
                @for (provider of providers; track provider) {
                <mat-option [value]="provider.id">{{
                  provider.name
                }}</mat-option>
                }
              </div>
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
        }
      </div>
      <div class="form-row">
        <div class="custom-form-field">
          <label for="administratorId">Administrator</label>
          <mat-form-field
            appearance="outline"
            class="custom-field sm"
            (click)="$event.stopPropagation()"
          >
            <mat-select
              formControlName="administratorId"
              name="administratorId"
            >
              <div class="options-container" #optionsAdministratorsContainer>
                @for (administrator of administrators; track administrator) {
                <mat-option [value]="administrator.id">{{
                  administrator.name
                }}</mat-option>
                }
              </div>
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
        @if (products.length > 0) {
          <div class="custom-form-field">
            <label for="productIds">Products</label>
            <app-mat-multi-select
              [size]="'sm'"
              [requiredMessage]="'Please select Products'"
              [options]="products"
              [control]="filterGroup.controls['productIds']"
              (click)="$event.stopPropagation()"
            />
          </div>
          } @else {
          <div class="custom-form-field w-100">
            <label for="emptyProducts">Products</label>
            <mat-form-field appearance="outline" class="custom-field sm">
              <input
                [disabled]="true"
                placeholder="Loading"
                matInput
                name="emptyProducts"
              />
            </mat-form-field>
          </div>
          }
      </div>
      <div class="form-row">
        @if (role !== 'Lender' || showLendersDropdown) {
          @if (lenders.length > 0) {
        <div class="custom-form-field">
          <label for="lenderIds">Lenders</label>
          <app-mat-multi-select-pagination
            [size]="'sm'"
            [requiredMessage]="'Please select Lenders'"
            [options]="lenders"
            [control]="filterGroup.controls['lenderIds']"
            [hasNextPage]="hasNextPageLenders"
            (loadMore)="onLoadMoreLenders($event)"
            (click)="$event.stopPropagation()"
          />
        </div>
        } @else {
        <div class="custom-form-field w-100">
          <label for="emptyLenders">Lenders</label>
          <mat-form-field appearance="outline" class="custom-field sm">
            <input
              [disabled]="true"
              placeholder="Loading"
              matInput
              name="emptyLenders"
            />
          </mat-form-field>
        </div>
        } }
        <div class="custom-form-field">
          <label for="statusId">Status</label>
          <mat-form-field
            appearance="outline"
            class="custom-field sm"
            (click)="$event.stopPropagation()"
          >
            <mat-select formControlName="status" name="status">
              @for (status of statusList; track status) {
              <mat-option [value]="status.id">{{ status.name }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="custom-form-field">
          <label for="submissionProgressId">Submission Progress</label>
          <mat-form-field
            appearance="outline"
            class="custom-field sm"
            (click)="$event.stopPropagation()"
          >
            <mat-select
              formControlName="submissionProgressId"
              name="submissionProgressId"
            >
              @for (submissionProgress of submissionProgressList; track
              submissionProgress) {
              <mat-option [value]="submissionProgress.id">{{
                submissionProgress.name
              }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
        @if (industries.length > 0) {
        <div class="custom-form-field">
          <label for="industryIds">Industry</label>
          <app-mat-multi-select
            [size]="'sm'"
            [options]="industries"
            [control]="filterGroup.controls['industryIds']"
            (click)="$event.stopPropagation()"
          />
        </div>
        } @else {
        <div class="custom-form-field w-100">
          <label for="emptyIndustries">Industry</label>
          <mat-form-field appearance="outline" class="custom-field sm">
            <input
              [disabled]="true"
              placeholder="Loading"
              matInput
              name="emptyIndustries"
            />
          </mat-form-field>
        </div>
        }
      </div>
      <div class="form-row">
        @if (states.length > 0) {
        <div class="custom-form-field">
          <label for="statesIds">States</label>
          <app-mat-multi-select
            [size]="'sm'"
            [requiredMessage]="'Please select States'"
            [options]="states"
            [control]="filterGroup.controls['statesIds']"
            (click)="$event.stopPropagation()"
          />
        </div>
        } @else {
        <div class="custom-form-field w-100">
          <label for="emptyStates">States</label>
          <mat-form-field appearance="outline" class="custom-field sm">
            <input
              [disabled]="true"
              placeholder="Loading"
              matInput
              name="emptyStates"
            />
          </mat-form-field>
        </div>
        }
        <div class="custom-form-field">
          <label for="formStatusId">Active/Inactive</label>
          <mat-form-field
            appearance="outline"
            class="custom-field sm"
            (click)="$event.stopPropagation()"
          >
            <mat-select
              formControlName="formStatusId"
              name="formStatusId"
            >
              @for (formStatus of formStatusList; track formStatus) {
              <mat-option [value]="formStatus.id">{{
                formStatus.name
              }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <button
          (click)="onApplyFilter()"
          mat-flat-button
          color="primary"
          type="button"
          class="apply-button"
        >
          Apply
        </button>
      </div>
    </div>
  </mat-menu>
  <mat-icon
    class="info-icon"
    matTooltip="Please enter at least 4 characters."
    matTooltipPosition="below"
    >info_outlined</mat-icon
  >
</form>
